import { render } from "./Contest.vue?vue&type=template&id=507b152b&scoped=true"
import script from "./Contest.vue?vue&type=script&lang=js"
export * from "./Contest.vue?vue&type=script&lang=js"

import "./Contest.vue?vue&type=style&index=0&id=507b152b&lang=less&scoped=true"

import exportComponent from "C:\\IdeaProjects\\frontEnd\\gdstiweb\\node_modules\\.pnpm\\registry.npmmirror.com+vue-loader@16.8.3_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@4.47.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-507b152b"]])

export default __exports__